import ULayout from "@/layout/mobile/user";
const routes = [
  {
    path: "/user",
    name: "userhome",
    component: ULayout,
    children: [
      {
        path: "",
        redirect: { name: "userIndex" },
      },
      {
        path: "index",
        name: "userIndex",
        component: (resolve) => require(["pages/mobile/user/index.vue"], resolve),
        meta: { showLeftMenu: true, requiresAuth: true },
      },
      {
        path: "info",
        name: "userInfo",
        component: (resolve) => require(["pages/mobile/user/info.vue"], resolve),
        meta: { showLeftMenu: true, requiresAuth: true },
      },
      {
        path: "address",
        name: "userAddress",
        component: (resolve) => require(["pages/mobile/user/address"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },
      {
        path: "pwd",
        name: "userPwd",
        component: (resolve) => require(["pages/mobile/user/pwd"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },

      {
        path: "notic",
        name: "userNotic",
        component: (resolve) => require(["pages/mobile/user/notic"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },

      {
        path: "orders",
        name: "userOrders",
        component: (resolve) => require(["pages/mobile/user/orders"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/m/user.js